<div class="min-h-screen bg-[#F3F4F6] dark:bg-slate-900 p-4 md:p-8 text-slate-600 dark:text-slate-300">
  <!-- Header -->
  <div class="animate-fade-in flex flex-col md:flex-row md:items-end justify-between mb-6 gap-4">
    <div>
      <h1 class="text-3xl font-extrabold text-slate-800 dark:text-slate-100 tracking-tight">ค้นหาเจ้าของรถ</h1>
      <p class="text-slate-500 dark:text-slate-400 mt-2 font-medium">ค้นหาทะเบียนรถ แล้วคลิกรายการเพื่อเปิดข้อมูลเจ้าของ</p>
    </div>
    <div class="flex items-center gap-3">
      <div *ngIf="lastFetchedTime" class="flex flex-col items-end text-right">
        <span class="text-[11px] text-slate-400 dark:text-slate-500 font-medium leading-none mb-1">ดึงข้อมูลล่าสุด</span>
        <span class="text-[13px] font-bold text-slate-600 dark:text-slate-400 leading-none">{{ lastFetchedTime | date:'HH:mm:ss' }}</span>
      </div>
      <button (click)="onRefresh()"
        class="p-3 bg-white dark:bg-slate-800 text-slate-500 dark:text-slate-400 rounded-xl shadow-sm border border-slate-200 dark:border-slate-700 hover:text-amber-500 dark:hover:text-amber-400 hover:shadow-md transition-all active:scale-95 flex items-center justify-center"
        title="รีเฟรชข้อมูล">
        <span class="material-icons">refresh</span>
      </button>
    </div>
  </div>

  <!-- Search Card -->
  <div class="animate-fade-in bg-white dark:bg-slate-800 rounded-3xl shadow-[0_4px_20px_rgb(0,0,0,0.03)] border border-slate-100 dark:border-slate-700 p-5 md:p-6 mb-6"
    style="animation-delay: 0.05s;">
    <div class="flex flex-col md:flex-row gap-3">
      <div
        class="relative flex items-center flex-1 bg-slate-50 dark:bg-slate-900 rounded-xl border border-slate-100 dark:border-slate-700 focus-within:bg-white dark:focus-within:bg-slate-800 focus-within:ring-2 focus-within:ring-amber-200 dark:focus-within:ring-amber-500/30 transition-all h-[52px]">
        <span class="pl-4 material-icons text-slate-400 dark:text-slate-500 text-2xl shrink-0">search</span>
        <input type="text" [(ngModel)]="searchText" (keyup.enter)="onSearch()" (keyup.escape)="clearSearch()"
          placeholder="พิมพ์ทะเบียนรถ ชื่อเจ้าของ ชื่อ LINE หรือเบอร์โทร แล้วกด Enter"
          class="flex-1 px-3 bg-transparent border-none text-base font-medium text-slate-700 dark:text-slate-200 focus:ring-0 focus:outline-none placeholder:text-slate-400 dark:placeholder:text-slate-600" />
        <button *ngIf="searchText" type="button" (click)="clearSearch()"
          class="mr-2 w-8 h-8 flex items-center justify-center rounded-full text-slate-400 hover:text-slate-700 hover:bg-slate-100 dark:hover:text-slate-200 dark:hover:bg-slate-700 transition-colors"
          title="ล้างคำค้นหา">
          <span class="material-icons text-[18px]">close</span>
        </button>
      </div>
      <button (click)="onSearch()"
        class="shrink-0 h-[52px] px-6 rounded-xl bg-amber-400 hover:bg-amber-500 text-white font-bold transition-all shadow-sm active:scale-95 flex items-center justify-center gap-1.5">
        <span class="material-icons text-[20px]">search</span>
        ค้นหา
      </button>
    </div>
    <div class="mt-3 flex flex-wrap items-center gap-2 text-xs text-slate-400 dark:text-slate-500">
      <span class="material-icons text-[16px]">info</span>
      <span>คลิกแถวหรือไอคอน</span>
      <span class="material-icons text-[16px]">person_search</span>
      <span>เพื่อเปิดโปรไฟล์ รถทั้งหมด และบัตรจอดของเจ้าของคนนั้น</span>
    </div>
  </div>

  <!-- Table Card -->
  <div class="animate-fade-in bg-white dark:bg-slate-800 rounded-3xl shadow-[0_4px_20px_rgb(0,0,0,0.03)] border border-slate-100 dark:border-slate-700 overflow-hidden"
    style="animation-delay: 0.1s;">
    <div class="px-6 py-4 border-b border-slate-100 dark:border-slate-700 flex items-center justify-between gap-4">
      <h3 class="text-lg font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
        <span class="material-icons text-amber-500">directions_car</span>
        รายการทะเบียนรถ
      </h3>
      <span class="px-3 py-1 rounded-full bg-slate-100 dark:bg-slate-700 text-xs font-bold text-slate-500 dark:text-slate-300">
        {{ totalItems | number }} คัน
      </span>
    </div>

    <div class="overflow-x-auto h-[600px] relative custom-scrollbar" [class.opacity-50]="isLoading">
      <table class="w-full text-left border-collapse">
        <thead class="sticky top-0 z-20 bg-white/95 dark:bg-slate-800/95 backdrop-blur-sm shadow-sm">
          <tr>
            <th class="px-5 py-4 text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider whitespace-nowrap w-16">#</th>
            <th class="px-5 py-4 text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider whitespace-nowrap">ทะเบียนรถ</th>
            <th class="px-5 py-4 text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider whitespace-nowrap">เจ้าของ</th>
            <th class="px-5 py-4 text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider whitespace-nowrap">เบอร์โทรศัพท์</th>
            <th class="px-5 py-4 text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider whitespace-nowrap text-center">การแชร์</th>
            <th class="px-5 py-4 text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider whitespace-nowrap">วันที่ลงทะเบียน</th>
            <th class="px-5 py-4 text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider whitespace-nowrap text-center">จัดการ</th>
          </tr>
        </thead>
        <tbody class="divide-y divide-slate-100 dark:divide-slate-700">
          <tr *ngFor="let v of vehicles; let i = index" (click)="openOwnerProfile(v)"
            class="animate-table-row group cursor-pointer hover:bg-slate-50 dark:hover:bg-slate-700/40 transition-colors duration-150"
            [ngStyle]="{'animation-delay': (i * 0.03) + 's'}">
            <td class="px-5 py-3 text-sm text-slate-400 dark:text-slate-500">{{ startItemIndex + i }}</td>

            <td class="px-5 py-3 whitespace-nowrap">
              <div class="text-sm font-bold text-slate-800 dark:text-slate-100 tracking-wide">{{ v.plateNumber || '-' }}</div>
              <div class="text-xs text-slate-400 dark:text-slate-500 mt-0.5">
                {{ v.provinceName || 'ไม่ระบุจังหวัด' }}
                <ng-container *ngIf="v.vehicleType"> · {{ v.vehicleType }}</ng-container>
              </div>
            </td>

            <td class="px-5 py-3 whitespace-nowrap">
              <div class="flex items-center gap-3">
                <div
                  class="w-8 h-8 rounded-full bg-slate-100 dark:bg-slate-700 flex items-center justify-center overflow-hidden shrink-0 text-slate-500 dark:text-slate-400 font-bold text-xs">
                  <img *ngIf="v.pictureUrl && !isPictureBroken(v.id); else ownerInitial"
                    [src]="v.pictureUrl" [alt]="v.ownerName || v.fullName || 'LINE'"
                    (error)="onPictureError(v.id)" class="w-full h-full object-cover" />
                  <ng-template #ownerInitial>{{ (v.ownerName || v.fullName || '?').charAt(0) }}</ng-template>
                </div>
                <div class="flex flex-col min-w-0">
                  <span class="text-sm font-medium text-slate-700 dark:text-slate-200 truncate">
                    {{ v.ownerName || v.fullName || 'ไม่ระบุ' }}
                  </span>
                  <span *ngIf="v.fullName && v.fullName !== v.ownerName"
                    class="text-xs text-slate-400 dark:text-slate-500 truncate">
                    LINE: {{ v.fullName }}
                  </span>
                </div>
              </div>
            </td>

            <td class="px-5 py-3 text-sm text-slate-600 dark:text-slate-300 whitespace-nowrap">{{ v.phone || '-' }}</td>

            <td class="px-5 py-3 text-center whitespace-nowrap">
              <button *ngIf="v.hasActiveShare; else noShare"
                type="button"
                (click)="$event.stopPropagation(); openShareMembers(v)"
                class="inline-flex items-center gap-1 text-sm text-slate-600 dark:text-slate-300 hover:text-slate-900 dark:hover:text-white hover:underline"
                title="ดูสมาชิกที่แชร์รถ">
                <span class="material-icons text-[16px] text-slate-400">group</span>
                {{ v.sharedMemberCount | number }} คน
              </button>
              <ng-template #noShare>
                <span class="text-slate-300 dark:text-slate-600">-</span>
              </ng-template>
            </td>

            <td class="px-5 py-3 text-sm text-slate-500 dark:text-slate-400 whitespace-nowrap">
              {{ formatDateTime(v.createDate) }}
            </td>

            <td class="px-5 py-3 text-center whitespace-nowrap">
              <div class="inline-flex items-center gap-1">
                <button type="button" (click)="$event.stopPropagation(); openOwnerProfile(v)"
                  class="inline-flex items-center justify-center w-8 h-8 rounded-lg text-slate-400 hover:text-slate-700 hover:bg-slate-100 dark:hover:text-slate-200 dark:hover:bg-slate-700 transition-colors"
                  title="ดูข้อมูลเจ้าของ">
                  <span class="material-icons text-[18px]">person_search</span>
                </button>
                <button type="button" (click)="$event.stopPropagation(); openActivityHistory(v.id)"
                  class="inline-flex items-center justify-center w-8 h-8 rounded-lg text-slate-400 hover:text-slate-700 hover:bg-slate-100 dark:hover:text-slate-200 dark:hover:bg-slate-700 transition-colors"
                  title="ประวัติทะเบียนรถ">
                  <span class="material-icons text-[18px]">history</span>
                </button>
              </div>
            </td>
          </tr>
          <tr *ngIf="vehicles.length === 0 && !isLoading">
            <td colspan="7" class="py-20 text-center">
              <div class="flex flex-col items-center justify-center">
                <div class="w-16 h-16 bg-slate-50 dark:bg-slate-800 rounded-full flex items-center justify-center mb-3">
                  <span class="material-icons text-3xl text-slate-300 dark:text-slate-600">search_off</span>
                </div>
                <h3 class="text-slate-800 dark:text-slate-200 font-bold">ไม่พบข้อมูลทะเบียนรถ</h3>
                <span class="text-slate-400 dark:text-slate-500 text-sm mt-1">ลองค้นหาด้วยทะเบียน ชื่อ หรือเบอร์โทรอื่น</span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div
      class="px-6 py-4 border-t border-slate-100 dark:border-slate-700 bg-white dark:bg-slate-800 flex flex-col md:flex-row items-center justify-between gap-4">
      <div class="flex items-center gap-4 text-sm text-slate-500 dark:text-slate-400 font-medium">
        <span>แสดง {{ startItemIndex | number }} - {{ endItemIndex | number }} จาก {{ totalItems | number }} รายการ</span>
        <select (change)="onPageSizeChange($event)" [(ngModel)]="pageSize"
          class="bg-slate-50 dark:bg-slate-900 border border-slate-200 dark:border-slate-700 text-slate-700 dark:text-slate-200 text-sm rounded-lg focus:ring-2 focus:ring-amber-100 dark:focus:ring-amber-500/30 focus:border-amber-400 dark:focus:border-amber-600 block p-1.5 pr-8 font-bold outline-none cursor-pointer hover:bg-white dark:hover:bg-slate-800 transition-colors">
          <option *ngFor="let size of pageSizeOptions" [value]="size">{{ size }} / หน้า</option>
        </select>
      </div>
      <div class="flex items-center gap-2">
        <button (click)="setPage(currentPage - 1)" [disabled]="currentPage === 1"
          class="w-9 h-9 flex items-center justify-center rounded-lg border border-slate-200 dark:border-slate-700 hover:bg-slate-50 dark:hover:bg-slate-700 hover:text-amber-500 dark:hover:text-amber-400 disabled:opacity-30 disabled:cursor-not-allowed transition-all text-slate-500 dark:text-slate-400">
          <span class="material-icons text-sm">chevron_left</span>
        </button>
        <button *ngFor="let p of pagesArray" (click)="setPage(p)"
          class="w-9 h-9 flex items-center justify-center rounded-lg text-sm font-bold transition-all"
          [ngClass]="p === currentPage ? 'bg-amber-400 dark:bg-amber-500 text-white shadow-lg shadow-amber-200 dark:shadow-none' : 'text-slate-600 dark:text-slate-300 hover:bg-amber-50 dark:hover:bg-slate-700 hover:text-amber-600 dark:hover:text-amber-400'">
          {{ p }}
        </button>
        <button (click)="setPage(currentPage + 1)" [disabled]="currentPage >= totalPages || totalPages === 0"
          class="w-9 h-9 flex items-center justify-center rounded-lg border border-slate-200 dark:border-slate-700 hover:bg-slate-50 dark:hover:bg-slate-700 hover:text-amber-500 dark:hover:text-amber-400 disabled:opacity-30 disabled:cursor-not-allowed transition-all text-slate-500 dark:text-slate-400">
          <span class="material-icons text-sm">chevron_right</span>
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Read-only vehicle share detail modal -->
<div *ngIf="isShareModalOpen"
  class="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/60 backdrop-blur-sm p-4"
  (click)="closeShareModal()">
  <div class="w-full max-w-2xl max-h-[85vh] overflow-hidden rounded-3xl bg-white dark:bg-slate-800 shadow-2xl border border-slate-100 dark:border-slate-700"
    (click)="$event.stopPropagation()">
    <div class="flex items-center justify-between gap-4 px-6 py-5 border-b border-slate-100 dark:border-slate-700">
      <div>
        <div class="flex items-center gap-2">
          <span class="material-icons text-emerald-500">group</span>
          <h2 class="text-xl font-extrabold text-slate-800 dark:text-slate-100">สมาชิกที่แชร์รถ</h2>
        </div>
        <p class="mt-1 text-sm text-slate-500 dark:text-slate-400">
          ทะเบียน {{ selectedVehicleShare?.plateNumber || '-' }}
        </p>
      </div>
      <button type="button" (click)="closeShareModal()"
        class="w-10 h-10 rounded-xl flex items-center justify-center text-slate-400 hover:text-slate-700 hover:bg-slate-100 dark:hover:text-slate-200 dark:hover:bg-slate-700 transition-colors"
        title="ปิด">
        <span class="material-icons">close</span>
      </button>
    </div>

    <div class="p-6 overflow-y-auto max-h-[calc(85vh-88px)] custom-scrollbar">
      <div *ngIf="isShareDetailLoading" class="py-16 flex flex-col items-center gap-3 text-slate-400">
        <span class="material-icons animate-spin text-3xl text-emerald-500">progress_activity</span>
        <span class="text-sm font-medium">กำลังโหลดข้อมูลสมาชิก...</span>
      </div>

      <ng-container *ngIf="!isShareDetailLoading">
        <div *ngIf="selectedVehicleShare?.activeGroup as group"
          class="mb-5 rounded-2xl bg-slate-50 dark:bg-slate-900/60 border border-slate-100 dark:border-slate-700 p-4">
          <span class="text-xs font-bold uppercase tracking-wider text-slate-400">เจ้าของกลุ่ม</span>
          <div class="mt-2 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-1">
            <span class="font-bold text-slate-700 dark:text-slate-200">{{ group.ownerName || '-' }}</span>
            <span class="text-sm text-slate-500 dark:text-slate-400">{{ group.ownerPhone || '-' }}</span>
          </div>
        </div>

        <div class="flex items-center justify-between mb-3">
          <h3 class="font-bold text-slate-700 dark:text-slate-200">รายชื่อสมาชิก</h3>
          <span class="px-2.5 py-1 rounded-full bg-emerald-50 dark:bg-emerald-900/30 text-emerald-700 dark:text-emerald-300 text-xs font-bold">
            {{ activeShareMembers.length | number }} คน
          </span>
        </div>

        <div *ngIf="activeShareMembers.length > 0; else noActiveMembers"
          class="divide-y divide-slate-100 dark:divide-slate-700 border border-slate-100 dark:border-slate-700 rounded-2xl overflow-hidden">
          <div *ngFor="let member of activeShareMembers"
            class="flex items-center gap-3 p-4 bg-white dark:bg-slate-800">
            <div class="w-10 h-10 shrink-0 rounded-full bg-emerald-50 dark:bg-emerald-900/30 text-emerald-600 dark:text-emerald-300 flex items-center justify-center font-bold">
              {{ member.name ? member.name.charAt(0) : '?' }}
            </div>
            <div class="min-w-0 flex-1">
              <div class="flex items-center gap-2">
                <span class="font-bold text-slate-700 dark:text-slate-200 truncate">{{ member.name || 'ไม่ระบุชื่อ' }}</span>
                <span class="px-2 py-0.5 rounded-full bg-slate-100 dark:bg-slate-700 text-[11px] font-bold text-slate-500 dark:text-slate-300">
                  {{ member.role || 'member' }}
                </span>
              </div>
              <div class="mt-1 text-xs text-slate-400 dark:text-slate-500 truncate">
                {{ member.phone || '-' }} · {{ member.uid || '-' }}
              </div>
            </div>
          </div>
        </div>

        <ng-template #noActiveMembers>
          <div class="py-12 text-center rounded-2xl border border-dashed border-slate-200 dark:border-slate-700 text-slate-400">
            ไม่พบสมาชิกที่ใช้งานอยู่
          </div>
        </ng-template>
      </ng-container>
    </div>
  </div>
</div>

<app-modal-line-oa-member *ngIf="isOwnerModalOpen && selectedOwner" [member]="selectedOwner"
  (close)="closeOwnerProfile()"></app-modal-line-oa-member>

<app-modal-admin-activity-history
  *ngIf="showActivityHistory && activityHistoryVehicleId"
  [entityType]="activityEntityTypes.Vehicle"
  [entityId]="activityHistoryVehicleId"
  title="ประวัติทะเบียนรถ"
  [subtitle]="'#' + activityHistoryVehicleId"
  (close)="closeActivityHistory()">
</app-modal-admin-activity-history>

<app-pss-loading *ngIf="isLoading"></app-pss-loading>
